// @ts-nocheck
/* eslint-disable */
export const appIconArrowDown12Icon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="icon-arrow-down-12_svg__Layer_1" x="0px" y="0px" viewBox="0 0 12 12" xml:space="preserve"><path stroke-linecap="round" fill="none" stroke="currentColor" d="M6,2v7.4"/><path stroke-linecap="round" fill="none" stroke="currentColor" d="M2.5,6.4L6,10l3.5-3.6"/></svg>`,
    name: 'icon-arrow-down-12' as const
};